import { computed, ref, type ComputedRef, type Ref } from "vue"

export function onHover() {
    const isHovered: Ref<boolean> = ref(false)
    const isClicked: Ref<boolean> = ref(false)
    const isTouchDevice: Ref<boolean> = ref(false)

    if (typeof window !== 'undefined') {
        isTouchDevice.value = 'ontouchstart' in window || navigator.maxTouchPoints > 0
    }

    const isActive: ComputedRef<boolean> = computed(() => isHovered.value || isClicked.value)

    const onPointerEnter = (): void => {
        if (!isTouchDevice.value) isHovered.value = true
    }

    const onPointerLeave = (): void => {
        if (!isTouchDevice.value) isHovered.value = false
    }

    const onClick = (): void => {
        if (isTouchDevice.value) isHovered.value = !isHovered.value
    }

    const onUnclick = (): void => {
        if (isTouchDevice.value) isHovered.value = false
    }

    return { isActive, isClicked, isHovered, onPointerEnter, onPointerLeave, onClick, onUnclick }
}